import * as S from './StepCard.styled';

interface IProps {
  activeStep: number;
  title: string;
  description: string;
  children: React.ReactNode;
}

export const StepCard = ({ activeStep, title, description, children }: IProps) => (
  <S.Container>
    <S.StepTitle>Step {activeStep + 1}</S.StepTitle>
    <S.Title>{title}</S.Title>
    <S.Description>{description}</S.Description>
    {children}
  </S.Container>
);
